var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arroba-medellin-mute"},[_c('button',{class:_vm.stateButton,on:{"click":function($event){return _vm.mutePage()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }